import { api } from "api/common";
import { GET_SETTINGS, SET_SETTINGS } from "api/constants";
import { setToastMessage } from "components/app/actions";
import { createActionsHook } from "react-redux-actions-hook";
import { SecurityActionType } from "./constants";

export const setPwdRstDialogOpen = (isOpen) => {
  return {
    type: SecurityActionType.SET_PWD_RESET_DIALOG_VISIBILITY,
    isOpen,
  };
};

export const setPwdStrengthDialogOpen = (isOpen) => {
  return {
    type: SecurityActionType.SET_PWD_STRENGTH_DIALOG_VISIBILITY,
    isOpen,
  };
};

export const setSettingsData = (data) => {
  return {
    type: SecurityActionType.SET_SETTINGS,
    data,
  };
};

export const setPasswordPolicy = (policy_name) => {
  return {
    type: SecurityActionType.CHANGE_POLICY,
    policy_name,
  };
};
export const getSettings = () => {
  return (dispatch) => {
    api(`${GET_SETTINGS}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(setSettingsData(response.data));
      })
      .catch((error) => {
        //do nothing
      });
  };
};

export const setSettings = (callback) => {
  return (dispatch, stateFn) => {
    const { security } = stateFn().security;
    api(
      `${SET_SETTINGS}`,
      { method: "PUT", body: JSON.stringify({ security }) },
      dispatch
    )
      .then((response) => {
        dispatch(
          setToastMessage(
            response.message || "Successfully registered",
            "success"
          )
        );
        callback();
        dispatch(getSettings());
      })
      .catch((error) => {
        //do nothing
      });
  };
};

export default createActionsHook({
  setPwdRstDialogOpen,
  setPwdStrengthDialogOpen,
  getSettings,
  setSettings,
  setPasswordPolicy,
});
